(() => {
  document.querySelectorAll('[data-paris-rsvp]').forEach(form => {
  if (form.dataset.ready) return;
  form.dataset.ready = 'true';
  const button = form.querySelector('button');
  const input = form.querySelector('input[name="email"]');
  const status = form.querySelector('[role="status"]');
  const label = button.innerHTML;
  button.disabled = false;
  form.addEventListener('submit', async event => {
    event.preventDefault();
    if (button.disabled || !form.reportValidity()) return;
    button.disabled = true;
    button.textContent = 'Enregistrement…';
    form.setAttribute('aria-busy', 'true');
    status.textContent = '';
    status.removeAttribute('data-error');
    const controller = new AbortController();
    const timeout = setTimeout(() => controller.abort(), 25000);
    try {
      const response = await fetch('https://shopify-inventory-worker.rubencharlestouitou.workers.dev/rsvp', {
        method: 'POST', headers: {'Content-Type': 'application/json'},
        body: JSON.stringify({email: input.value.trim()}), signal: controller.signal,
        credentials: 'omit',
      });
      const result = await response.json();
      if (!response.ok || result.ok !== true) throw new Error(response.status === 429
        ? 'Veuillez patienter une minute avant de réessayer.'
        : 'Votre inscription n’a pas pu être confirmée. Merci de réessayer.');
      form.querySelector('[data-rsvp-fields]').hidden = true;
      status.textContent = 'Merci ! Votre présence est confirmée. À dimanche 4 octobre, à 14h-17h.';
      status.focus();
    } catch (error) {
      status.setAttribute('data-error', '');
      status.textContent = error.message.startsWith('Veuillez') || error.message.startsWith('Votre inscription')
        ? error.message : 'La connexion a échoué. Merci de réessayer.';
      button.disabled = false;
    } finally {
      clearTimeout(timeout);
      button.innerHTML = label;
      form.removeAttribute('aria-busy');
    }
  });
  });
})();
